import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { useDispatchActions, setStoreState } from './utils'
import { storageUtil, cal } from '@/utils'

export interface UserInfo {
  uid: string
  nikeName: string
  duid: string
  guildId: number
  role?: number
  cacheUserRole?: number
  [key: string]: any
}

const initialState: UserInfo = {
  uid: '',
  nikeName: '',
  duid: '',
  guildId: 0
}

export const slice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserInfo>) => {
      const cacheUserInfo = storageUtil.getSessionStorage('userInfo', true) || {}
      const payload = {
        ...action.payload,
        gemstone: cal.divide(action.payload.gemstone,  100),
      }

      if (action.payload.cacheUserRole as number >= 0) {
        payload.cacheUserRole = action.payload.cacheUserRole
      } else if (cacheUserInfo.cacheUserRole >= 0 && cacheUserInfo.uid === action.payload.uid) {
        payload.cacheUserRole = cacheUserInfo.cacheUserRole
      } else {
        payload.cacheUserRole = action.payload.agent === 1 ? 0 : 1 // 0 代理商 1 主播
      }

      setStoreState(state, payload)
      storageUtil.setSessionStorage('userInfo', JSON.stringify(payload))
    },
  },
})

export const { setUserInfo: userInfoActionCreator } = slice.actions
export const reducer = slice.reducer

export default function useCorpInfoStore() {
  const state = useSelector((state: RootState) => state.userInfo)
  const storageState = storageUtil.getSessionStorage('userInfo', true) || {}
  const actionPool = useDispatchActions(slice.actions)
  const totalState = { ...state, ...storageState }

  return {
    userInfo: totalState,
    ...actionPool,
  }
}
